module.exports = __webpack_public_path__ + "img/brand-06.6e1d1316.png";